import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface HookProps {
  goodItemId: string;
  id: string;
}
export const useDeleteScreenshot = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ goodItemId, id }: HookProps) => {
      if (goodItemId?.length) {
        const formData = new FormData();
        formData.append('goodItemId', goodItemId);
        const { declaration } = await request({
          path: `declarations/${id}/deleteScreenshot`,
          method: 'POST',
          authenticate: true,
          dataObject: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return declaration;
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.id] });
      toast.success('Screenshot was deleted successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error deleting the screenshot!`);
    },
  });
};
